<template>
  <div>
    <vxe-grid
      ref="skuTable"
      border
      auto-resize
      highlight-hover-row
      :toolbar-config="{ slots: { buttons: 'toolbar_form' } }"
      :data="tableData"
      :columns="tableColumns"
      cell-class-name="align-top"
      size="mini"
      :edit-config="{ enabled: !disabled, trigger: 'click', mode: 'row' }"
      :edit-rules="editRules"
      @edit-closed="editClosed"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic-square.jpg'
          "
          :preview-src-list="[
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg',
          ]"
          style="width:60px; height:60px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic-square.jpg"
              style="width:60px; height:60px"
            />
          </div>
        </el-image>
        <div>
          <el-tooltip
            v-if="!disabled"
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:displayName="{ row }">
        <span>SKU:</span><span style="color: #409EFF">{{ row.evgSkuNo }}</span>
        <br />
        <span>{{ row.brandName }}</span>
        <br />
        <span>{{ row.combineName }}</span>
        <br />
        <span>{{ row.combineNameEn }}</span>
      </template>
      <template v-slot:displayColor="{ row }">
        <span style="color: #303133">{{ row.combineColor }}</span>
        <br />
        <span style="color: #303133"
          >{{ row.goodsColor }} &nbsp; {{ row.combineColorEn }}</span
        >
      </template>
      <template v-slot:primary="{ row }">
        <el-select
          v-model="row.isPrimary"
          :placeholder="$l('tips_select_isPrimary') || '请选择是否主产品...'"
          filterable
          clearable
          size="mini"
          style="width: 100%;"
          @change="change(row)"
        >
          <el-option value="Y" :label="'是'"> </el-option>
          <el-option value="N" :label="'否'"> </el-option>
        </el-select>
      </template>
      <template v-slot:ftyPrice="{ row }">
        {{ row.ftyPrice || '' }}
        {{ row.v_ftyPriceCurrencyUnit || '' }}
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './sku-table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableColumns: tableColumns(this),
      editRules: {
        isPrimaryText: [
          {
            required: true,
            message: this.$l('tips_select_isPrimary') || '请选择是否主产品',
          },
        ],
        inCombineQty: [
          {
            type: 'number',
            required: true,
            message: this.$l('tips_input_inCombineQty') || '请输入组合内数量	',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue) {
                return new Error(
                  this.$l('tips_inCombineQty_than_0') || '组合内数量必须大于0'
                )
              }
            },
          },
        ],
      },
    }
  },
  methods: {
    getTableData() {
      const { fullData } = this.$refs.skuTable.getTableData()
      return (fullData || []).map((item) => {
        const { brandCodeText: brandName } = item
        return { ...item, brandName }
      })
    },
    async reloadData(data) {
      this.$refs.skuTable.reloadData(data)
    },
    async validate() {
      const result = await this.$refs.skuTable.validate(true)
      return !result
    },
    del(row) {
      this.$emit('delRow', row)
    },
    change(row) {
      row.isPrimaryText = row.isPrimary === 'Y' ? '是' : '否'
      const {
        isPrimary,
        eanCode,
        evgSkuCode,
        combineName,
        combineNameEn,
        combineColorCode,
        combineColor,
        combineColorEn,
        combinePattern,
        combineStyle,
        combineSize,
        brandCode,
        brandName,
        masterCategoryCode,
        masterCategoryName,
        detailCategoryCode,
        detailCategoryName,
        defaultImageCode,
        defaultImageUrl,
        custCode,
      } = row
      if (isPrimary === 'Y') {
        this.$emit('updateFormData', {
          eanCode,
          evgSkuCode,
          combineName,
          combineNameEn,
          combineColorCode,
          combineColor,
          combineColorEn,
          combinePattern,
          combineStyle,
          combineSize,
          brandCode,
          brandName,
          masterCategoryCode,
          masterCategoryName,
          categoryCode: detailCategoryCode,
          categoryName: detailCategoryName,
          detailCategoryCode,
          detailCategoryName,
          defaultImageCode,
          defaultImageUrl,
          custCode,
        })
      }
    },
    async editClosed({ column = {}, row = {} }) {
      if (column.property === 'inCombineQty') {
        this.$emit('updateFtyPrice')
        return
      }
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .vxe-cell {
    > div {
      margin-top: 7px;
    }
  }
  .vxe-table--render-default .vxe-body--row:first-child .vxe-cell--valid {
    top: initial;
    padding-top: 4px;
  }
  .col-opt {
    padding-top: 0 !important;
  }
  .col--seq {
    padding-top: 11px !important;
  }
}
</style>
